import { observable, runInAction } from 'mobx';
import { IWasteProductServices, WasteProductModel } from 'services/RawData/wasteProduct_services';
import { DataResponse } from 'services/response';

export type wasteProductStore = {
  // Type default response search
  searchWasteProductResponse: DataResponse<Array<WasteProductModel>>;
  wasteProductDetailResponse: DataResponse<WasteProductModel | undefined>;
  crudResponse: DataResponse<null>;
};

export interface IWasteProductPresenter {
  createStore(): wasteProductStore;
  // Search waste product
  searchWasteProduct(store: wasteProductStore, data: object): Promise<void>;
  // Create waste product
  createWasteProduct(store: wasteProductStore, data: object): Promise<void>;
  // Update waste product
  updateWasteProduct(store: wasteProductStore, data: object): Promise<void>;
  // Get waste product by WasteProductId
  getWasteProductById(store: wasteProductStore, WasteProductId: string): Promise<void>;
  // Export waste product template
  exportWasteProductTemplate(data: object): Promise<void>;
  // Export waste products for create new
  exportWasteProducts(data: object): Promise<void>;
  // Import create new waste products from excel
  importWasteProductsCreate(file: File): Promise<DataResponse<any>>;
  // Update waste product status
  updateWasteProductStatus(store: wasteProductStore, data: object): Promise<DataResponse<null>>;

  exportTemplateUpdateRequireConfirmPlan(data: object): Promise<void>;
  importWasteProductsUpdate(file: File): Promise<DataResponse<any>>;
}

export function createWasteProductPresenter({ wasteProductServices }: { wasteProductServices: IWasteProductServices }): IWasteProductPresenter {
  return {
    createStore: () =>
      observable({
        searchWasteProductResponse: {
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
          message: '',
          isSuccess: false,
        },
        wasteProductDetailResponse: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        crudResponse: {
          data: null,
          message: '',
          isSuccess: false,
        },
      }),
    // Search waste product
    searchWasteProduct: async (store, data) => {
      try {
        const result = await wasteProductServices.searchWasteProducts(data);
        runInAction(() => {
          store.searchWasteProductResponse.data = result.data;
          store.searchWasteProductResponse.isSuccess = result.isSuccess;
          store.searchWasteProductResponse.message = result.message;
          store.searchWasteProductResponse.paging = {
            totalCount: result.paging?.pagesCount,
            recordsTotal: result.paging?.recordsTotal,
            pageSize: result.paging?.resultsCount,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    createWasteProduct: async (store, data) => {
      try {
        const result = await wasteProductServices.createWasteProduct(data);
        runInAction(() => {
          store.crudResponse.isSuccess = result.isSuccess;
          store.crudResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    updateWasteProduct: async (store, data) => {
      try {
        const result = await wasteProductServices.updateWasteProduct(data);
        runInAction(() => {
          store.crudResponse.isSuccess = result.isSuccess;
          store.crudResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    getWasteProductById: async (store, WasteProductId) => {
      try {
        const result = await wasteProductServices.getDetailWasteProduct(WasteProductId);
        runInAction(() => {
          store.wasteProductDetailResponse.isSuccess = result.isSuccess;
          store.wasteProductDetailResponse.data = result.data;
          store.wasteProductDetailResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Export waste product template
    exportWasteProductTemplate: async (data) => {
      try {
        await wasteProductServices.exportWasteProductTemplate(data);
      } catch (error) {
        console.log(error);
      }
    },
    // Export waste products for create new
    exportWasteProducts: async (data) => {
      try {
        await wasteProductServices.exportWasteProducts(data);
      } catch (error) {
        console.log(error);
      }
    },
    // Import create new waste products from excel
    importWasteProductsCreate: async (file) => {
      try {
        return await wasteProductServices.importWasteProductsCreate(file);
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: 'Có lỗi xảy ra khi import',
          data: null,
        } as DataResponse<any>;
      }
    },
    // Update waste product status
    updateWasteProductStatus: async (store, data) => {
      try {
        const result = await wasteProductServices.updateWasteProductStatus(data);
        runInAction(() => {
          store.crudResponse.isSuccess = result.isSuccess;
          store.crudResponse.message = result.message;
        });
        return result;
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: 'Có lỗi xảy ra khi cập nhật trạng thái',
          data: null,
        } as DataResponse<null>;
      }
    },

    // để user dùng
    exportTemplateUpdateRequireConfirmPlan: async (data) => {
      try {
        await wasteProductServices.exportTemplateUpdateRequireConfirmPlan(data);
      } catch (error) {
        console.log(error);
      }
    },
    // Import create new waste products from excel
    importWasteProductsUpdate: async (file) => {
      try {
        return await wasteProductServices.importWasteProductsUpdate(file);
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: 'Có lỗi xảy ra khi import',
          data: null,
        } as DataResponse<any>;
      }
    },
  };


}

